import { useCallback } from 'react'
import { useTablePageSizeStore } from '@/stores/useTablePageSizeStore'

export function usePersistedPageSize(
  tableKey: string,
  defaultSize: number
): [number, (size: number) => void] {
  const pageSize = useTablePageSizeStore(
    state => state.pageSizeByTable[tableKey] ?? defaultSize
  )
  const setPageSizeInStore = useTablePageSizeStore(state => state.setPageSize)

  const setPageSize = useCallback(
    (size: number) => setPageSizeInStore(tableKey, size),
    [tableKey, setPageSizeInStore]
  )

  return [pageSize, setPageSize]
}
